module.exports = require("@magento/peregrine/lib/talons/Wishlist/AddToListButton/addToListButton.gql");